<template>
  <div class="loading_wrapper">
    <div>
      <div class="loading">
      <div class="loading_circle"></div>
      <div class="loading_blob"></div>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style="display: none;">
      <defs>
        <filter id="tooltip-filter">
          <feGaussianBlur in="SourceGraphic" stdDeviation="9" result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
          <feComposite in="SourceGraphic" in2="goo" operator="atop"/>
        </filter>
      </defs>
    </svg>

    <p class="loading_txt">{{ $store.getters.t('로그인 중입니다...') }}</p>
    </div>
  </div>
</template>
  
  <script>
  import SocialApi from '@/api/social/SocialApi';
  export default {
    async created() {
      const urlParams = new URLSearchParams(window.location.search);
      console.log("urlParams => ", urlParams);

      const code = urlParams.get('code');
      console.log("코드 => ", code);
      
      if (code) {
        console.log("존재!");
        try {
            const response = await SocialApi.callBack(code);
            // console.log("response => ", response);
            const datas = response.access_token;
            console.log("token => ", datas)
          
          sessionStorage.setItem('google_access_token', datas.access_token);
          sessionStorage.setItem('google_refresh_token', datas.refresh_token);

          this.$router.push({ name: 'asset' });
        } catch (error) {
          console.error('Error during Google authentication: ', error);
          this.$router.push({ name: 'dashboard' });
        }
      } else {
        this.$router.push({ name: 'dashboard' });
      }
    }
  }
  </script>

<style lang="scss" scoped>
.loading_wrapper {display: flex;align-items: center;justify-content: center;height: 100%;}
.loading_txt {text-align: center; margin-top: 50px;color: #777;}

$loader-color: #d5e9ff;
$loader-size: 100px;
$blob-size: 56px;
$canvas-size: 190px;
$canvas-padding: 24px;
$ease-in: cubic-bezier(0.02, 0.01, 0.21, 1);
$ease-out: cubic-bezier(0.3, 0.27, 0.07, 1.64);

.loading {width: $canvas-size;height: $canvas-size;position: relative;padding: $canvas-padding;filter:url("#tooltip-filter");transform: rotate(0deg);animation: rotate 5s forwards infinite linear;}
.loading_circle,.Loader-blob {position: absolute;}
.loading_circle {width: $loader-size;height: $loader-size;top: 50%;left: 50%;transform: translate(-50%, -50%);border-radius: 50%;background-color: $loader-color;}

.loading_blob {width: $blob-size;height: $blob-size;bottom: $canvas-padding;left: $canvas-padding;animation: xAxis 2.5s infinite $ease-in;}
.loading_blob::after {content:'';display: block;width: 100%;height: 100%;background-color: $loader-color;border-radius: 50%;position: absolute;animation: yAxis 2.5s infinite $ease-out alternate;}
.loading_blob::before {content:'';display: block;width: 100%;height: 100%;background-color: $loader-color;border-radius: 50%;position: absolute;animation: yAxis 2.5s infinite $ease-out 2.5s;}

@keyframes xAxis {
  50% {
    animation-timing-function: $ease-in;transform: translateX($canvas-size - $blob-size);
  }
}

@keyframes yAxis {
  50% {
    animation-timing-function: $ease-out;transform: translateY(-($canvas-size - $blob-size));
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>